module.exports = __webpack_public_path__ + "img/15.5.COD.f851cdcf.png";